import styled from "styled-components";

import { TextField } from "@mui/material";
export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 98vw;
  height: 90%;
  margin-top: 1
  %;
`;
export const sidebarbutton = styled.div`
  position: absolute;
    top: 80px;
    left: 10%;
    border-top-left-radius: 0; 
    border-bottom-left-radius: 0; 
    border-top-right-radius: 20px; 
    border-bottom-right-radius: 20px;
     background-color: #fff;
`;
export const ContainerForm = styled.div`
  background-color: #fff;
  padding: 1rem 3rem 3rem 3rem;
  width: 60%;
  border-radius: 1.5rem;
  margin-top: -8%;

`;

export const TextFieldStyled = styled(TextField)`
  background-color: #f3f3f3;
`;
